import Vue,{ createApp }  from 'vue' 
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import helpers from './helpers'
import { i18n } from './i18n'
import '@vueform/multiselect/themes/default.css';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import '@wiris/mathtype-generic/wirisplugin-generic.js'
 

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`
}

const app = createApp(App)
app.use(i18n)
  .use(store)
  .use(router)
  .mount('#app')

app.config.globalProperties.$helpers = helpers
 